import GlobalBreadcrumbsMixin from "../../../shared/Mixins/GlobalBreadcrumbsMixin";
import ComponentMixin from "../../../shared/Mixins/ComponentMixin";

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  mounted () {
    this.setBreadcrumb("Customers", { name: "All Customers" });
  },

  methods: {
    navigateToShowRoute (response) {
      this.$router.push({
        name: "Show Customer",
        params: {
          id: response.resource.id
        }
      });
    },

    navigateToIndexRoute () {
      this.$router.push({
        name: "All Customers"
      });
    }
  }
};
